export class WelcomeOkModel {
    orderNo: string;
    description: string;
    amount: string;
    currency: string;
    customerFirstName: string;
    customerLastName: string;
    merchantName: string;
    merchantAddress: string;
    paymentId: string;
    paymentDate: Date;
    paymentStatus: string;
    mid: string;
    storeKey: string;
    apiUser: string;
    apiPassword: string;
    language: string;
    merchantOrderNumber: string;
    redirectUrl: string;
    callbackUrl: string;
    nestPayGateUrl: string;
    email: string;
}
